import React, { useMemo } from 'react';
import { Platform, StyleSheet, TextInput, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import Text from '@/components/Typography/Text';

const createStyles = (colors, withoutSpacing = false, isPrimary = false) => StyleSheet.create({
  textareaInputContainer: {
    width: '100%',
    minWidth: 300,
    paddingHorizontal: withoutSpacing ? 0 : 10,
    marginBottom: withoutSpacing ? 0 : 15,
  },
  textareaInputWrapper: {
    backgroundColor: isPrimary ? colors.solid_color_primary : colors.solid_color_tertiary,
    borderColor: isPrimary ? colors.border_color_secondary : 'transparent',
    borderWidth: isPrimary ? 1 : 0,
    borderRadius: 8,
  },
  textareaInput: {
    color: colors.text_color_primary,
    paddingHorizontal: 12,
    paddingVertical: 8,
    minHeight: 88,
    maxHeight: 220,
    width: '100%',
    fontSize: 14,
    lineHeight: 18,
    border: 'none',
    resize: 'vertical',
    outlineStyle: 'none',
  },
  textareaLengthText: {
    fontSize: 12,
    color: colors.text_color_tertiary,
    marginTop: 5,
    marginBottom: withoutSpacing ? 0 : -10,
    fontStyle: 'italic',
  },
});

const TextareaControl = ({ param, onChange, withoutSpacing = false, isPrimary = false }) => {
  const { colors } = useTheme();
  const styles = useMemo(() => createStyles(colors, withoutSpacing, isPrimary), [colors, withoutSpacing, isPrimary]);
  const minLen = param?.validation?.string?.minLength;
  const maxLen = param?.validation?.string?.maxLength;
  const currentLen = typeof param?.value === 'string' ? param.value.length : 0;

  return (
    <View style={styles.textareaInputContainer}>
      <View style={styles.textareaInputWrapper}>
        <TextInput
          multiline={true}
          value={param.value}
          onChangeText={onChange}
          placeholder={param.ui.placeholder}
          placeholderTextColor={colors.text_color_tertiary}
          style={styles.textareaInput}
          maxLength={maxLen || undefined}
          {...Platform.select({
            web: {
              minLength: minLen || undefined,
            }
          })}
        />
      </View>
      {(minLen || maxLen) && (
        <Text style={styles.textareaLengthText}>
          {`${currentLen}${maxLen ? `/${maxLen}` : ''}${minLen ? ` • min ${minLen}` : ''}`}
        </Text>
      )}
    </View>
  );
};

export default TextareaControl;

